import { Typography, Box } from '@mui/material';
import { IFormRegister, IFormValues } from 'routes/Main/type';
import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormRegister, IFormValues {
  disabled?: boolean;
}

const contents = [
  '在某些情況下，可能有其他替代輸血的選擇，包括用生理鹽水或其他人工化合物進行液體補充和/或鐵補充劑。',
  '您的醫生將與您討論這些選項，因為某些選擇並不適合所有人。',
  '(醫生在提供的空白處記錄。如有必要，請繼續記錄在病歷中。）',
];

const contents2 = ['(醫生在提供的空白處記錄。如有必要，請繼續記錄在病歷中。）'];

const DEContents = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <>
      <SectionTitle title="D. 其他相關治療選項" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        {contents.map((v, i) => (
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '14px',
              lineHeight: '38px',
              whiteSpace: 'pre',
            }}
          >
            {v}
          </Typography>
        ))}
      </Box>

      <SectionTitle title="E. 未進行血液和/或血液製品輸血的風險" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        {contents2.map((v, i) => (
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '14px',
              lineHeight: '38px',
              whiteSpace: 'pre',
            }}
          >
            {v}
          </Typography>
        ))}
      </Box>
    </>
  );
};

export default DEContents;
